export const NO_HOTELS_TITLE_TEXT = "No hotels found";
export const NO_HOTELS_FILTER_SUBTITLE_TEXT =
  "Reset filters or adjust your dates to view more hotels.";
export const NO_HOTELS_RETURNED_SUBTITLE_TEXT =
  "Adjust your dates or search again to view more hotels.";

export const RESET_BUTTON_TEXT = "Reset filters";
export const SEARCH_AGAIN_BUTTON_TEXT = "Search again";
export const ADJUST_DATES_BUTTON_TEXT = "Adjust dates";
